<div class="text-center app-loader-container">
  @if (closable) {
  <button
    mat-icon-button
    class="app-loader-close-btn"
    title="Cancel this request"
    (click)="close()"
  >
    <mat-icon>close</mat-icon>
  </button>
  }
  <h6 class="m-0 pb-16" style="white-space: pre-wrap; line-height: 1.4">{{ title }}</h6>
  <div mat-dialog-content>
    <mat-spinner [style.margin]="'auto'"></mat-spinner>
  </div>
</div>
